import { TASKS_SERVICE_URL } from "@coworker/app/src/hooks/API/tasks.service.helper";
import {
  createAuthorizationHeader,
  throwIfNotOk,
  toJson,
} from "@coworker/apprestructured/src/task-management/services/fetchHelper";
import { FileUploadType } from "@fixa/platform-shared/dist/fileUpload/fileUpload.type";

const BASE_URL = `${TASKS_SERVICE_URL}/uploads`;

export const NO_WRITE_SIGNED_URLS: SignedUrlResponse[] = [];

export type SignedUrlResponse = {
  fileName: string;
  originalFileName: string;
  signedUrl: string;
};

export async function getWriteSignedUrls(
  fileNames: string[],
  uploadType: FileUploadType
): Promise<SignedUrlResponse[]> {
  if (fileNames.length === 0) {
    return NO_WRITE_SIGNED_URLS;
  }
  const urlSearchParams = new URLSearchParams();
  urlSearchParams.append("fileNames", JSON.stringify(fileNames));
  urlSearchParams.append("uploadType", uploadType);
  return toJson<SignedUrlResponse[]>(
    await fetch(`${BASE_URL}/write-signed-urls?${urlSearchParams.toString()}`, {
      method: "GET",
      headers: {
        ...(await createAuthorizationHeader()),
        "Content-Type": "application/json",
      },
    })
  );
}

export type SignedFile = {
  file: File;
  signedUrl: string;
};

async function uploadSignedFileToBucket(signedFile: SignedFile) {
  return throwIfNotOk(
    await fetch(signedFile.signedUrl, {
      method: "PUT",
      headers: {
        "Content-Type": signedFile.file.type,
      },
      body: signedFile.file,
    })
  );
}

export async function uploadSignedFilesToBucket(signedFiles: SignedFile[]) {
  await Promise.all(
    signedFiles.map((signedFile) => {
      return uploadSignedFileToBucket(signedFile);
    })
  );
}
